import { pletApiRequest } from './client';

// `workspaceId` (optional, may be null/'personal') pins the request to the
// workspace that was active when the operation was initiated — see client.js.
export const SettingsAPI = {
  get: async ({ workspaceId } = {}) => {
    const result = await pletApiRequest('/settings', { workspaceId });
    return result.settings;
  },

  save: async (settings, { workspaceId } = {}) => {
    const result = await pletApiRequest('/settings', {
      method: 'PUT',
      body: JSON.stringify(settings),
      workspaceId,
    });
    return result.settings;
  },
};
